import { useEffect } from 'react'
import { useIsDark, useIsDarkListener } from '@highlight/ui'
import { useGlobalStore } from '@highlight/ipc/react'
import { isBrowserRuntime } from '@renderer/browser/browser-utils'

export { useIsDark }

export const useThemeListener = () => {
  useIsDarkListener()
  const isDark = useIsDark()
  const [theme] = useGlobalStore<string>('settings', 'theme', 'system')

  useEffect(() => {
    const html = document.documentElement
    if (isDark) {
      html.classList.add('dark')
    } else {
      html.classList.remove('dark')
    }

    if (isDark && theme === 'dark-low-contrast') {
      html.classList.add('low-contrast')
    } else {
      html.classList.remove('low-contrast')
    }

    if (isBrowserRuntime()) {
      html.style.backgroundColor = isDark ? 'black' : ''
    }
  }, [isDark, theme])

  return null
}
